window.addEventListener('load', function () {
    setTimeout(() => { }, 500);
    const cartcheckoutBtn = document.querySelector('.btn.cart__checkout');
    const config = document.getElementById('cart-popup-config');
    const loginUrl = config.dataset.loginUrl;
    const registerUrl = config.dataset.registerUrl;
    // カート商品をチェック
    if (cartcheckoutBtn) {
        cartcheckoutBtn.addEventListener('click', function (e) {
            if (typeof checkLineItemValidation === 'function') {
                const result = checkLineItemValidation();
                if (!result.validationFlag) {
                    return;
                }
            }
            const cartItems = document.querySelectorAll('.cart__item');
            console.log('カート商品数', cartItems.length);
            //商品に.property-wrist-sizeがあるかチェック
            let hasWristSize = false;
            let hasEmptyWristSize = false;

            cartItems.forEach((item) => {
                const wristSizeSelect = item.querySelector('.property-wrist-size');
                console.log('wristSizeSelect', wristSizeSelect);
                if (wristSizeSelect) {
                    hasWristSize = true;
                    console.log('property-wrist-sizeがある');
                    if (!wristSizeSelect.value || wristSizeSelect.value === '') {
                        hasEmptyWristSize = true;
                        console.log('property-wrist-sizeが空白');
                    }
                }
            });

            // property-wrist-sizeが空白かチェック
            // 空白の商品がある場合はポップアップを表示しない
            if (hasWristSize && hasEmptyWristSize) {
                console.log('空白の商品がある');
                return;
            }

            // property-wrist-sizeが1つも無い、または全て入力済みならpopup
            showPopup();
        });
    }

    function showPopup() {
        console.log('ボタンの元の機能を削除');
        // ポップアップを追加
        const overlay = document.createElement('div');
        overlay.className = 'popup-overlay';

        const popup = document.createElement('div');
        popup.className = 'cartPopup';

        const loginButton = document.createElement('button');
        loginButton.className = 'logintoBuy';
        loginButton.textContent = 'ログイン';

        loginButton.addEventListener('click', function () {
            window.location.href = loginUrl;
        });

        const loginBoxtitle = document.createElement('p');
        loginBoxtitle.className = 'loginBoxtitle';
        loginBoxtitle.textContent = 'アカウントをお持ちの方';
        //loginBoxtitle.textContent = 'Grand Seiko IDをお持ちの方';

        const loginBoxtext = document.createElement('p');
        loginBoxtext.className = 'loginBoxtext';
        //loginBoxtext.className = 'loginBoxtext font-gothic';
        loginBoxtext.innerHTML = 'すでにご登録いただいている場合は<br>ログインしてご注文いただけます。';

        const registerLink = document.createElement('p');
        registerLink.className = 'registerLink link-hover-animation font-gothic';
        registerLink.textContent = '新規会員登録はこちら';

        registerLink.addEventListener('click', function () {
            window.location.href = registerUrl;
        });


        const loginBox = document.createElement('div');
        loginBox.className = 'loginBox';
        loginBox.appendChild(loginBoxtitle);
        loginBox.appendChild(loginBoxtext);
        loginBox.appendChild(loginButton);
        loginBox.appendChild(registerLink);

        const border2 = document.createElement('div');
        border2.className = 'cart-border-line';

        const gestButton = document.createElement('button');
        gestButton.className = 'gestBtn';
        gestButton.textContent = 'ゲストで購入';

        const gestBoxtitle = document.createElement('p');
        gestBoxtitle.className = 'gestBoxtitle';
        gestBoxtitle.textContent = 'ゲスト購入の方';

        const gestBoxtext = document.createElement('p');
        gestBoxtext.className = 'gestBoxtext';
        //gestBoxtext.className = 'gestBoxtext font-gothic';
        gestBoxtext.textContent = '会員登録せずに注文される方はこちら';

        const gestBox = document.createElement('div');
        gestBox.className = 'gestBox';
        gestBox.appendChild(gestBoxtitle);
        gestBox.appendChild(gestBoxtext);
        gestBox.appendChild(gestButton);

        const doublebuttonContainer = document.createElement('div');
        doublebuttonContainer.id = 'doubleBtn';
        doublebuttonContainer.className = 'doubleBtn';

        const allbuttonContainer = document.createElement('div');
        allbuttonContainer.id = 'alltoBtn';
        allbuttonContainer.className = 'alltoBtn';

        fetch('/cart.js')
            .then((response) => response.json())
            .then((cart) => {
                // カートトークンを使用してチェックアウトURLを生成
                const checkoutUrl = `/checkout?checkout[customer_id]=${cart.token}`;
                gestButton.addEventListener('click', function () {
                    window.location.href = checkoutUrl;
                });
            })
            .catch((error) => console.error('Error fetching cart information:', error));

        doublebuttonContainer.appendChild(loginBox);

        allbuttonContainer.appendChild(doublebuttonContainer);
        allbuttonContainer.appendChild(border2);
        allbuttonContainer.appendChild(gestBox);

        //       allbuttonContainer.appendChild(loginButton);
        //       allbuttonContainer.appendChild(gestButton);

        const closeButton = 'http://www.w3.org/2000/svg';
        const buttonElement = document.createElementNS(closeButton, 'svg');
        buttonElement.setAttribute('class', 'closeBtn');
        buttonElement.setAttribute('viewBox', '0 0 21.54 20.707');
        buttonElement.setAttribute('width', '16.54');
        buttonElement.setAttribute('height', '16.707');

        const lineElement = document.createElementNS(closeButton, 'g');
        lineElement.setAttribute('transform', 'translate(-27.933 -22.646)');

        const lineRight = document.createElementNS(closeButton, 'line');
        lineRight.setAttribute('x1', '20');
        lineRight.setAttribute('y2', '20');
        lineRight.setAttribute('transform', 'translate(28.286 23)');
        lineRight.setAttribute('fill', 'none');
        lineRight.setAttribute('stroke', '#454545');
        lineRight.setAttribute('stroke-width', '1');

        const lineLeft = document.createElementNS(closeButton, 'line');
        lineLeft.setAttribute('x1', '19.977');
        lineLeft.setAttribute('y1', '19.977');
        lineLeft.setAttribute('transform', 'translate(29.142 23)');
        lineLeft.setAttribute('fill', 'none');
        lineLeft.setAttribute('stroke', '#454545');
        lineLeft.setAttribute('stroke-width', '1');

        lineElement.appendChild(lineRight);
        lineElement.appendChild(lineLeft);

        buttonElement.appendChild(lineElement);

        buttonElement.addEventListener('click', function () {
            document.body.removeChild(overlay);
            document.body.removeChild(popup);
            document.body.classList.remove('no-scroll');
        });

        // ポップアップに要素を追加
        popup.appendChild(buttonElement);
        popup.appendChild(allbuttonContainer);

        // DOMにポップアップとオーバーレイを追加
        document.body.appendChild(overlay);
        document.body.appendChild(popup);

        document.body.classList.add('no-scroll');
    }
});